// removed by extract-text-webpack-plugin
module.exports = {"forecast":"weather_forecast_x","forecast__icons":"weather_forecast_x__icons","day":"weather_forecast_day","dow":"weather_forecast_dow","hi-lo":"weather_forecast_hi-lo","min-degrees":"weather_forecast_min-degrees","icons":"weather_forecast_icons","conditionIcon":"weather_forecast_conditionIcon"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/weather-widget/src/components/forecast/style.less
// module id = 1164
// module chunks = 1